import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import './styles.css';

export interface TitleWithSelectorOption {
  value: string;
  label: string;
}

export interface TitleWithSelectorProps {
  title: string;
  options: TitleWithSelectorOption[];
  selectedValue: string;
  onChange: (value: string) => void;
}

export const TitleWithSelector: React.FC<TitleWithSelectorProps> = ({
  title,
  options,
  selectedValue,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const selectedLabel = options.find(opt => opt.value === selectedValue)?.label || 'Select...';

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (value: string) => {
    onChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="title-with-selector">
      <span className="title-prefix">{title}:</span>
      <div className="selector-wrapper" ref={dropdownRef}>
        <button className="selector-button" onClick={handleToggle} aria-haspopup="true" aria-expanded={isOpen}>
          <span className="selected-value">{selectedLabel}</span>
          <FiChevronDown className={`chevron-icon ${isOpen ? 'open' : ''}`} />
        </button>
        {isOpen && (
          <div className="selector-dropdown">
            <ul>
              {options.map(option => (
                <li key={option.value}>
                  <button 
                    onClick={() => handleSelect(option.value)}
                    className={selectedValue === option.value ? 'selected' : ''}
                  >
                    {option.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default TitleWithSelector;
